"use client";

import React from "react";
import { Clock, Award, GraduationCap } from "lucide-react";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const benefitsData = [{
  title: "Local Brighton Expertise",
  description: "Deeply rooted in the Brighton & Hove community, we understand local needs and provide care that feels like home.",
  icon: Clock
}, {
  title: "Family-Focused Care",
  description: "We treat your loved ones like our own family, ensuring emotional support and companionship alongside physical care.",
  icon: Award
}, {
  title: "Highly Trained Staff",
  description: "Our CQC-registered team undergoes rigorous training to deliver premium healthcare with compassion and clinical excellence.",
  icon: GraduationCap
}];
export default function BenefitsOfLearning() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="222704" id="why-families-choose-cynthylee" className="bg-secondary py-16 md:py-20">
      <div className="container mx-auto px-4 md:px-6">
        <div className="mb-12 text-center">
          <h2 className="font-default text-foreground text-3xl md:text-5xl font-bold tracking-tight">
            Why Families Choose Cynthylee
          </h2>
          <p className="text-muted-foreground mt-4 max-w-2xl mx-auto text-lg font-default">
            Providing premium, compassionate home care across Brighton & Hove with a commitment to dignity and independence.
          </p>
        </div>

        <div ref={ref} className={`grid grid-cols-1 md:grid-cols-3 gap-8 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          {benefitsData.map((benefit, i) => {
          const Icon = benefit.icon;
          return <div data-index={i} key={i} className="h-full">
                <Card className="bg-card border-border shadow-md hover:shadow-xl hover:-translate-y-1 transition-all duration-300 h-full flex flex-col rounded-2xl">
                  <CardHeader className="pb-4">
                    <div className="bg-primary/10 w-16 h-16 rounded-2xl flex items-center justify-center mb-6">
                      <span className="font-default text-primary text-2xl font-bold">0{i + 1}</span>
                    </div>
                    <CardTitle className="font-default text-xl md:text-2xl text-foreground font-semibold">
                      {benefit.title}
                    </CardTitle>
                  </CardHeader>
                  <CardContent className="flex-grow">
                    <p className="text-muted-foreground leading-relaxed font-default">
                      {benefit.description}
                    </p>
                  </CardContent>
                </Card>
              </div>;
        })}
        </div>
      </div>
    </section>;
}